<template>
	<div class="coupon-code" v-if="isCouponVisible">
		<div class="coupon-header" :style="getStyle(node)">
			GUNAKAN KODE KUPON:
		</div>
		<div class="form-group">
			<div class="coupon-container">
				<input
					type="text"
					name="coupon"
					v-model="code"
					class="form-control coupon-field ooef-field-coupon valid"
					:class="{
						'coupon-field-success': isCouponValid,
						'coupon-field-failed': isCouponError,
					}"
					autocomplete="nope">
				<button
					type="button"
					class="coupon-button coupon-apply-button"
					:style="{
						display: code.length > 0 && !isCouponValid && !isCouponError ? 'inline-block' : 'none',
					}">
					Apply
				</button>
				<button
					type="button"
					class="coupon-button coupon-remove-button"
					:style="{
						display: isCouponValid ? 'inline-block' : 'none',
					}">
					<span class="coupon-apply-button-remove-check coupon-icon-check">
						<i class="fas fa-check"></i>
					</span>
					<span class="coupon-apply-button-remove-times coupon-icon-times">
						<i class="fas fa-times"></i>
					</span>
				</button>
				<button
					type="button"
					class="coupon-button coupon-remove-button-failed"
					:style="{
						display: isCouponError ? 'inline-block' : 'none',
					}">
					<span class="coupon-apply-button-failed-remove-times">
						<i class="fas fa-times"></i>
					</span>
				</button>
			</div>
			<div class="coupon-error" v-if="isCouponError">
				{{ errorMessage }}
			</div>
		</div>
	</div>
</template>

<script>
// import globalApi from '@/api/global';
// eslint-disable-next-line
import { getAxiosErrorMessage, getNodeStyle } from '@/lib/helper';
import {
	// eslint-disable-next-line
	paymentChannels,
} from '@/lib/statics';

export default {
	name: 'Coupon',
	props: {
		node: Object,
		product: {
			type: Object,
			default: null,
		},
		shipping: {
			type: Object,
			default: null,
		},
		selectedPayment: {
			type: Object,
			default: null,
		},
		contact: {
			type: Object,
			default: null,
		},
		simpleVariation: {
			type: Object,
			default: null,
		},
		multipleVariation: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			code: '',
			isCouponValid: false,
			isCouponError: false,
			errorMessage: '',
		};
	},
	computed: {
		productId() {
			const id = this.product?._id;
			return id;
		},

		paymentMethod() {
			const method = this.selectedPayment?.key || 'bank_transfer';
			return method;
		},

		shippingCost() {
			let cost = 0;
			if (this.shipping !== null && this.shipping.cost && this.shipping.cost.length > 0) {
				cost = this.shipping.cost[0].value;
			}
			return cost;
		},

		quantity() {
			let quantity = 0;
			if (this.contact !== null && this.contact.quantity) {
				quantity = this.contact.quantity;
			}
			return quantity;
		},

		productType() {
			let type = 'simple';
			if (this.product !== null && this.product.type) {
				type = this.product.type;
			}
			return type;
		},

		isMultipleVariant() {
			let isVariant = false;
			if (this.product !== null && this.product.variations.multiple_variations) {
				isVariant = this.product.variations.multiple_variations.enabled;
			}
			return isVariant;
		},

		selectedVariation() {
			return this.simpleVariation;
		},

		selectedMultipleVariation() {
			const variations = this.multipleVariation.length > 0
				? this.multipleVariation.filter(curr => curr.quantity > 0)
				: [];
			return variations;
		},

		isCouponVisible() {
			const visible = this?.product?.form?.elements?.coupon?.enabled ?? true;
			return visible;
		},
	},
	watch: {
		selectedPayment(value) {
			if (value && value !== null) {
				this.applyCoupon();
			}
		},
	},
	methods: {
		applyCoupon() {},

		removeCoupon() {
			this.code = '';
			this.isCouponValid = false;
			this.isCouponError = false;
			this.errorMessage = '';
			this.setCoupon(null);
		},

		setCoupon(coupon) {
			this.$emit('set-coupon', coupon);
		},

		getStyle({ options }) {
			const styles = [
				'text-color',
			];
			const style = getNodeStyle(options, styles);
			return style;
		},
	},
};
</script>

<style>

</style>
